import { FaRegHeart } from 'react-icons/fa';

export default function StreamEnd() {
  return (
    <section
      id="about"
      className="relative p-10 min-h-screen flex flex-col md:flex-row items-center justify-center gap-12 px-6 text-white overflow-hidden
             bg-gradient-to-r from-blue-950 via-indigo-900 via-purple-950 via-slate-900 to-blue-950
             bg-[length:400%_400%] animate-gradient"
    >
      {/* Background snowflake */}
      <img
        src="img/snowflake.svg"
        alt="Snowflake"
        className="absolute -top-32 -right-40 w-[700px] opacity-[5%] pointer-events-none select-none"
        style={{
          transformOrigin: 'center',
          animation: 'spin 60s linear infinite',
        }}
      />

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      {/* Santa image on the left */}
      <img
        src="img/giveaway.svg"
        alt="Santa Claus"
        className="w-24 m-10 drop-shadow-2xl z-10"
      />

      {/* Main content */}
      <div className="max-w-2xl relative z-10">
        <h1 className="text-5xl md:text-6xl font-extrabold mb-4">
          Helsinki{' '}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-red-500 to-pink-700">
            Reloaded
          </span>
        </h1>
        <p
          className={'mb-4 mt-6 text-4xl font-semibold flex gap-3 items-center'}
        >
          <span>Stream ending</span> <FaRegHeart className={'text-4xl'} />
        </p>
        <p className="md:text-lg text-gray-300 mb-4">
          Thank you all for joining us today! The winner of the Scenery Giveaway
          will be announced on Tuesday.
        </p>
        <p className="md:text-lg text-gray-300 mb-4">
          Don’t forget to join us every Thursday evening in HEL!
        </p>
      </div>
    </section>
  );
}
